export default __webpack_public_path__ + "static/media/blockafric.119966a7.png";